import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { baseURL } from "../../constants/pathnames";
import Body from "../Home/Body";
import Table from "../Table/Table";
import UserReqs from "./UserReqs";
import UserAds from "./UserAds";
import UserPromotedAds from "./UserPromotedAds";
import UserPlans from "./UserPlans";
import Button from "../Button/Button";
import ModalEditProfile from "./ModalEditProfile";
import ModalUserDeactive from "./ModalUserDeactive";

const UserDetail = () => {
  const { token } = useSelector((state) => state.users);
  const history = useHistory();
  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);

  const { id } = useParams();
  const [isModalEditProfile, setIsModalEditProfile] = useState(false);
  const [isModalUserDeactive, setIsModalUserDeactive] = useState(false);
  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const columns = [
    // { Header: "شماره", accessor: "counter" },
    { Header: "نام و نام خانوادگی", accessor: "name" },
    { Header: "نام کاربری", accessor: "username" },
    { Header: "استان", accessor: "province" },
    { Header: "شهر", accessor: "city" },
    { Header: "پست الکترونیکی", accessor: "email" },
    { Header: "کد معرف", accessor: "code" },
    { Header: "شماره تماس", accessor: "phone" },
    { Header: "وضعیت", accessor: "status" },
  ];

  const getData = useCallback(() => {
    debugger;
    axios
      .get(`${baseURL}auth/panel/update/${id}/`, header)
      .then((res) => {
        console.log(res.data);
        setData(res.data);
        setRows([
          {
            name: res.data?.first_name + " " + res.data?.last_name,
            username: res.data?.username,
            province: res.data?.province_detail?.name,
            city: res.data?.city_detail?.name,
            email: res.data?.email,
            code: res.data?.invite_code,
            phone: res.data?.phone_number,
            status: res.data?.is_active ? (
              <div className='color-green2'>فعال</div>
            ) : (
              <div className='color-red'>غیرفعال</div>
            ),
          },
        ]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id, header]);
  useEffect(() => {
    getData();
  }, [getData]);
  return (
    <>
      <Body state={1}>
        <div className='overflow-y-auto overflow-x-hidden'>
          <>
            <div className='flex justify-between items-center gap-3 h-16 mb-10'>
              {/* back arrow */}
              <div className='flex justify-start items-center font-semibold gap-4 py-4'>
                <img
                  className='cursor-pointer'
                  src='/statics/images/arrow-right-black1.svg'
                  width='16px'
                  height='16px'
                  alt='arrow'
                  onClick={() => {
                    history.goBack();
                  }}
                />
                <span>جزئیات کاربر</span>
              </div>

              <div className='m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8'>
                <img
                  className='mx-auto '
                  src='/statics/images/bell.svg'
                  width='16'
                  height='16'
                  alt='bell'
                />
              </div>
            </div>

            <div className='shadow rounded-xl my-5 border'>
              <Table
                classs='paneltable UserDetailTable'
                columns={columns}
                data={rows}
              />
            </div>

            <div className='flex justify-end items-center'>
              <Button
                title='ویرایش اطلاعات'
                backgroundColor='#fff'
                color='#204086'
                borderColor='#204086'
                borderWidth='2px'
                margin='0 8px'
                maxWidth='120px'
                fontSize='12px'
                maxHeight='40px'
                onClick={() => {
                  setIsModalEditProfile(true);
                }}
              />
              <Button
                title={
                  data.is_active
                    ? "غیرفعال کردن این کاربر"
                    : "فعال کردن این کاربر"
                }
                backgroundColor='#fff'
                color='#cf4e4e'
                borderColor='#cf4e4e'
                borderWidth='2px'
                margin='0 8px'
                fontSize='12px'
                maxWidth='150px'
                maxHeight='40px'
                onClick={() => {
                  setIsModalUserDeactive(true);
                }}
              />
            </div>
          </>

          <UserReqs userid={id} />
          <UserAds userid={id} />
          <UserPromotedAds userid={id} />
          <UserPlans userid={id} />
        </div>
      </Body>

      {isModalEditProfile && (
        <ModalEditProfile
          onCancel={() => setIsModalEditProfile(!isModalEditProfile)}
          data={data}
          getdata={getData}
        />
      )}

      {isModalUserDeactive && (
        <ModalUserDeactive
          onCancel={() => setIsModalUserDeactive(!isModalUserDeactive)}
          getdata={getData}
          id={data.id}
          is_active={data.is_active}
        />
      )}
    </>
  );
};

export default UserDetail;
